import * as React from "react";

const BalanceBar = ({
  count,
  onClick,
  isDisabled,
}: {
  count: number;
  onClick: () => void;
  isDisabled: boolean;
}) => {
  return (
    <div className="w-full flex pt-[25px] pb-[35px] items-center justify-center">
      <button
        onClick={onClick}
        className={`${isDisabled ? "bg-primary-gray text-black pointer-events-none" : "bg-primary-blue text-white pointer-events-auto"} text-center leading-[1.2] py-[10px] px-[15px] hover:opacity-80 ${isDisabled ? " cursor-not-allowed" : ""}`}
      >
        <p className="text-[24px] uppercase">claim rest</p>
        <p className="text-[15px] lowercase">balance: {count} TON</p>
      </button>
    </div>
  );
};

export default BalanceBar;
